(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2882],{

/***/ 84626:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[slug]",
      function () {
        return __webpack_require__(38992);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50930);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19453);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83242);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73267);
/* harmony import */ var _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17566);
/* harmony import */ var _dy_commons_components__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_components__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76079);
/* harmony import */ var _dy_commons_utils__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_dy_commons_utils__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  flex-grow: 2;\n  overflow: hidden;\n  position: relative;\n\n  ",
        " {\n    overflow: unset;\n  }\n\n  ",
        " {\n    margin: 0 auto;\n    max-width: 1650px;\n  }\n\n  .marquee {\n    ",
        " {\n      grid-column: 1 / span 12;\n      left: calc(-50vw + 50%);\n      position: relative;\n      width: 100vw;\n      width: 100dvw;\n    }\n  }\n  .feria {\n    display: flex;\n    flex-direction: column;\n    ",
        " {\n      flex-direction: row;\n    }\n\n    > a {\n      background-image: unset;\n      background-position: unset;\n      background-repeat: unset;\n      background-size: unset;\n      position: unset;\n      transition: unset;\n\n      &:hover,\n      &.active {\n        background-size: unset;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}









// ORIGINAL
// const getContentsSections = (sections) => sections.map((section, idx) => {
//   return (
//     <SectionContents key={idx} section={section} />
//   )
// })
// CMS HACK
// added hack to simulate content with 2 rows ( not yet ready in the CMS)
var getContentsSections = function() {
    var sections = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var jumpIdx = null;
    return sections.map(function(section, idx) {
        if (jumpIdx && jumpIdx === idx) {
            jumpIdx = null;
        } else {
            var columnsGrouped = null;
            if (section.rows === 2) {
                var ref;
                jumpIdx = idx + 1;
                var nextSectionColumns = (ref = sections[idx + 1]) === null || ref === void 0 ? void 0 : ref.columns;
                columnsGrouped = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(section.columns).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(nextSectionColumns));
            }
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__.SectionContents, {
                section: columnsGrouped ? {
                    rows: section.rows,
                    columns: columnsGrouped
                } : section
            }, idx);
        }
    });
};
var ContentsPage = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(function(param) {
    var data = param.data, dataForProducts = param.dataForProducts;
    var title = data.title, subtitle = data.subtitle, contents = data.contents, seo = data.seo, slug = data.slug;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)(), localeRouter = ref.locale;
    var locale = (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_6__.getLang)(localeRouter);
    var allCategories = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,_dy_commons_utils__WEBPACK_IMPORTED_MODULE_6__.getAllCategories)(slug, locale, dataForProducts.categories);
    }, [
        slug,
        locale,
        dataForProducts
    ]);
    var ContentsSections = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return getContentsSections(contents);
    }, [
        contents
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_dy_commons_components__WEBPACK_IMPORTED_MODULE_5__.HeadTag, {
                seo: seo,
                jsonld: {
                    data: data,
                    pageType: "contents"
                },
                slug: slug,
                pageType: "contents"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components__WEBPACK_IMPORTED_MODULE_3__.HeaderContents, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                        children: title
                    }),
                    subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        children: subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Main, {
                children: [
                    ContentsSections,
                    dataForProducts.variants.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__.SectionShop, {
                        data: {
                            variants: dataForProducts.variants,
                            categories: allCategories
                        },
                        pageCategory: "".concat(slug === null || slug === void 0 ? void 0 : slug[locale], "/category")
                    })
                ]
            })
        ]
    });
});
ContentsPage.Layout = _components__WEBPACK_IMPORTED_MODULE_3__.Layout;
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ContentsPage);
var Main = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].main.withConfig({
    displayName: "[slug]__Main",
    componentId: "sc-ece5d9bb-0"
})(_templateObject(), (0,_dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.designGrid)({
    withoutGutter: true
}), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("tablet"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("desktop-wide"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("tablet"), _dy_commons_styles__WEBPACK_IMPORTED_MODULE_4__.mq.greaterThan("tablet"));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(84626); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);